// FILECONTENT_START src/common/components/Inputs/Switch/index.ts
import Switch from "./Switch";
export default Switch;
export type { SwitchProps } from "./Switch";

// FILECONTENT_END src/common/components/Inputs/Switch/index.ts